/* eslint-disable */
// WARNING: this file is generated by a script, don't change it manually!
export const Primary = {
  "default": {
    "main": "#185ADD",
    "hover": "#3370E9",
    "pressed": "#6698FC",
    "active": "#0B2863",
    "selected": "#0F3786",
    "text": "#FFFFFF"
  },
  "container": {
    "main": "#E9EFFC",
    "hover": "#D7E3FE",
    "pressed": "#ADC8FF",
    "active": "#88AFFE",
    "selected": "#88AFFE",
    "text": "#0B2863"
  },
  "surface": {
    "main": "transparent",
    "hover": "#E9EFFC",
    "pressed": "#D7E3FE",
    "active": "#E9EFFC",
    "selected": "#F2F5FC",
    "text": "#185ADD"
  }
};

export const Secondary = {
  "default": {
    "main": "#34353D",
    "hover": "#6A6662",
    "pressed": "#A19991",
    "active": "#1E1F24",
    "selected": "#0D0E11",
    "text": "#FFFFFF"
  },
  "container": {
    "main": "#E9E5E2",
    "hover": "#DED9D4",
    "pressed": "#D2CBC5",
    "active": "#B9B2AC",
    "selected": "#B9B2AC",
    "text": "#0D0E11"
  },
  "surface": {
    "main": "transparent",
    "hover": "#E9E5E2",
    "pressed": "#DED9D4",
    "active": "#D2CBC5",
    "selected": "#E9EFFC",
    "text": "#0D0E11",
    "border": "#0D0E11"
  },
  "defaultInverse": {
    "main": "#FFFFFF",
    "hover": "rgba(255,255,255,0.9)",
    "pressed": "rgba(255,255,255,0.8)",
    "active": "rgba(255,255,255,0.7)",
    "text": "#34353D"
  },
  "surfaceInverse": {
    "main": "transparent",
    "hover": "rgba(255,255,255,0.12)",
    "pressed": "rgba(255,255,255,0.16)",
    "active": "rgba(255,255,255,0.2)",
    "text": "#FFFFFF",
    "border": "#FFFFFF"
  }
};

export const Calendar = {
  "surface": {
    "main": "transparent",
    "hoverMain": "#E9EFFC",
    "hoverVariant": "#185ADD",
    "selectedMain": "#185ADD",
    "selectedVariant": "#F2F5FC",
    "textMain": "#1E1F24",
    "textSelected": "#FFFFFF",
    "textActive": "#185ADD",
    "border": "#185ADD"
  }
};

export const Background = {
  "main": "#FBFAF9",
  "variant": "#F6F3F0",
  "light": "#FFFFFF",
  "inverse": "#34353D"
};

export const Surface = {
  "main": "#FFFFFF",
  "variant": "#FBFAF9",
  "dark": "#F6F3F0",
  "inverse": "#34353D"
};

export const Content = {
  "main": "#1E1F24",
  "variant": "#4D4E56",
  "tertiary": "#878078",
  "inverse": "#FFFFFF"
};

export const Border = {
  "default": {
    "main": "#E9E5E2",
    "selected": "#0D0E11"
  },
  "primary": {
    "main": "#ADC8FF",
    "selected": "#0F3786"
  },
  "variant": {
    "main": "#DED9D4"
  },
  "brand": {
    "main": "#0D0E11"
  }
};

export const Disabled = {
  "default": {
    "main": "#E9E5E2",
    "text": "#B9B2AC"
  },
  "surface": {
    "main": "transparent",
    "text": "#B9B2AC",
    "border": "#E9E5E2"
  },
  "defaultInverse": {
    "main": "rgba(255,255,255,0.12)",
    "text": "rgba(255,255,255,0.4)"
  },
  "surfaceInverse": {
    "main": "transparent",
    "text": "rgba(255,255,255,0.4)",
    "border": "rgba(255,255,255,0.12)"
  }
};

export const Backdrop = {
  "main": "rgba(52,53,61,0.4)"
};

export const Status = {
  "available": "#17874F",
  "idle": "#FF9935",
  "dnd": "#C51414",
  "offline": "#D2CBC5",
  "unknown": "#1E1F24",
  "border": "#FFFFFF"
};

export const Info = {
  "default": {
    "main": "#3841B0",
    "text": "#FFFFFF"
  },
  "container": {
    "main": "#F3F5FD",
    "text": "#1A2067"
  }
};

export const Success = {
  "default": {
    "main": "#17874F",
    "text": "#FFFFFF"
  },
  "container": {
    "main": "#F5FEF9",
    "text": "#137343"
  }
};

export const Warning = {
  "default": {
    "main": "#FF9935",
    "text": "#0D0E11"
  },
  "container": {
    "main": "#FFF4EB",
    "text": "#975102"
  }
};

export const Error = {
  "default": {
    "main": "#C51414",
    "hover": "#E52C2C",
    "pressed": "#FB6767",
    "active": "#570000",
    "selected": "#7D0808",
    "text": "#FFFFFF"
  },
  "container": {
    "main": "#FFF5F5",
    "hover": "#FFD6D6",
    "pressed": "#FFB3B3",
    "active": "#FD8181",
    "selected": "#FD8181",
    "text": "#7D0808"
  },
  "surface": {
    "main": "transparent",
    "hover": "#FFF5F5",
    "pressed": "#FFEBEB",
    "active": "#FFE1E1",
    "selected": "#FFF5F5",
    "text": "#C51414",
    "border": "#C51414"
  }
};

export const Link = {
  "main": "#185ADD",
  "visited": "#7A29A3",
  "inverse": "#FFFFFF"
};

export const Focused = {
  "main": "#5089FC",
  "inverse": "#FFFFFF"
};

export const Brand1 = {
  "main": "#260888",
  "text": "#FFFFFF",
  "containerMain": "#F3F5FD",
  "containerText": "#1A2067"
};

export const Brand2 = {
  "main": "#FF5500",
  "text": "#FFFFFF",
  "containerMain": "#FFEADF",
  "containerText": "#B23B00"
};

export const Brand3 = {
  "main": "#FA8B1E",
  "text": "#1A2067",
  "containerMain": "#FFEBDA",
  "containerText": "#975102"
};

export const Brand4 = {
  "main": "#FFAA00",
  "text": "#1A2067",
  "containerMain": "#FFEBC3",
  "containerText": "#8F5F00"
};

export const Brand5 = {
  "main": "#0F8A8A",
  "text": "#FFFFFF",
  "containerMain": "#E5FAFA",
  "containerText": "#0A5C5C"
};
